import { IconExternalLink } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { searchStore } from "features/ProductSearch/SearchStore";
import { ComponentDetailsEPDGroupOUT } from "api-client";
import SearchSortTable from "components/Table";
import clsx from "clsx";
import { ColumnDef } from "@tanstack/react-table";
import { FIELDSSET_TITLE_CLASSES } from "features/MappingEditor/consts";
import { EPDDocuments } from "../useProducDetalsModal";

const DocumentsTable = (props: {
  epdGroups?: ComponentDetailsEPDGroupOUT[];
  epdDocuments?: EPDDocuments[];
  containerClassName?: string;
}) => {
  const { t } = useTranslation();

  if (
    searchStore.currentDetailNode?.type === "COMPONENT" ||
    !props?.epdDocuments?.length
  )
    return;

  const getColumns = () =>
    React.useMemo<ColumnDef<EPDDocuments>[]>(
      () => [
        {
          id: "title",
          cell: (info: { row: { original: EPDDocuments } }) =>
            info.row.original.title,
          header: () => <div>{t("mapping.document")}</div>,
          enableColumnFilter: false,
          enableSorting: false,
          maxSize: 300,
          minSize: 240,
        },
        {
          id: "associatedEPD",
          cell: (info: { row: { original: EPDDocuments } }) => (
            <div>{info.row.original.epd_name}</div>
          ),
          header: () => <div>{t("mapping.associatedEPD")}</div>,
          enableColumnFilter: false,
          enableSorting: false,
          minSize: 200,
        },
        {
          id: "source",
          cell: (info: { row: { original: EPDDocuments } }) =>
            info.row.original?.provider === "Sentinel"
              ? "Sentinel Holding Institut (SHI)"
              : info.row.original?.provider,
          header: () => <div>{t("mapping.source")}</div>,
          enableColumnFilter: false,
          enableSorting: false,
          minSize: 220,
        },
        {
          id: "url",
          cell: (info: { row: { original: EPDDocuments } }) => (
            <div className="flex justify-center">
              <IconExternalLink
                className="cursor-pointer text-indigo-700"
                stroke={3}
                size={15}
                onClick={() =>
                  info.row.original?.link &&
                  window.open(info.row.original.link, "_blank")
                }
              />
            </div>
          ),
          maxSize: 35,
          enableColumnFilter: false,
          enableSorting: false,
        },
      ],
      []
    );

  return (
    <div
      className={clsx(
        "w-full pb-6 border-b border-gray-200 pt-4",
        props.containerClassName
      )}
    >
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("mapping.documentWithMoreInfo")}
      </div>
      <div className="border !rounded-md border-gray-300 text-gray-900 text-xs overflow-hidden w-full">
        <SearchSortTable
          data={props.epdDocuments}
          getColumns={getColumns as () => ColumnDef<unknown, unknown>[]}
          headerRowStyle="bg-white whitespace-nowrap"
          headerColumnStyle="border-r last-of-type:border-r-0"
          headerDivStyle="!py-1"
          customColumnStyle="border-r last-of-type:border-r-0 whitespace-nowrap !py-1 !px-2"
          enableTooltip
        />
      </div>
    </div>
  );
};

export default observer(DocumentsTable);
